import { render, staticRenderFns } from "./buyerPaysShippingDialog.vue?vue&type=template&id=dda249fc&scoped=true"
import script from "./buyerPaysShippingDialog.vue?vue&type=script&lang=js"
export * from "./buyerPaysShippingDialog.vue?vue&type=script&lang=js"
import style0 from "./buyerPaysShippingDialog.vue?vue&type=style&index=0&id=dda249fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda249fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dda249fc')) {
      api.createRecord('dda249fc', component.options)
    } else {
      api.reload('dda249fc', component.options)
    }
    module.hot.accept("./buyerPaysShippingDialog.vue?vue&type=template&id=dda249fc&scoped=true", function () {
      api.rerender('dda249fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/sepecialOrderPrint/components/buyerPaysShippingDialog.vue"
export default component.exports